<ng-template ngIf="!error">
    <app-verify-email *ngIf="error_description === 'verify_email'" [clientID]="hoge" ></app-verify-email>
    <!-- <app-access-denied [description]="error_description" *ngIf="error === 'access_denied'"></app-access-denied> -->
</ng-template>
